import React, { Component } from 'react';
import styled from 'styled-components';
import ErrorMessage from '@zocdoc-frontend-common/components-errormessage';
import Textbox from '@zocdoc-frontend-common/components-textbox';
import { Column, Row as BaseRow } from '@zocdoc-frontend-common/styles-grid';
import { FormRow } from '@zocdoc-frontend-common/styles-grid';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { blue100, red80 } from '@zocdoc-mezzanine/foundations-colors';

export const BIRTH_DAY = 'birth_day';
export const BIRTH_MONTH = 'birth_month';
export const BIRTH_YEAR = 'birth_year';

/**
 * @param {boolean} error
 * @param {function(): void} onBlur
 * @param {function(): void} onChange
 * @param {function(): void} onFocus
 * @returns {JSX.Element}
 * @constructor
 */
export default class DobPicker extends Component {
    render() {
        const { onFocus, onBlur, onChange, error } = this.props;
        return (
            <FormRow>
                <FormLabel>Date of birth</FormLabel>
                <Row>
                    <Column size={8}>
                        <StyledTextBox
                            className="exclude-from-playback"
                            data-test="birth-month"
                            data-uem-id="birth-month"
                            name={BIRTH_MONTH}
                            placeholder="MM"
                            type="tel"
                            defaultValue={''}
                            onChange={(e) => {
                                onChange('birthMonth', e.target.value);
                            }}
                            onFocus={() => {
                                onFocus('birthMonth');
                            }}
                            invalid={error}
                            onBlur={(e) => {
                                onBlur('birthMonth', e.target.value);
                            }}
                        />
                    </Column>

                    <Column size={8}>
                        <StyledTextBox
                            className="exclude-from-playback"
                            data-test="birth-day"
                            data-uem-id="birth-day"
                            name={BIRTH_DAY}
                            placeholder="DD"
                            type="tel"
                            defaultValue={''}
                            invalid={error}
                            onChange={(e) => {
                                onChange('birthDay', e.target.value);
                            }}
                            onFocus={() => {
                                onFocus('birthDay');
                            }}
                            onBlur={(e) => {
                                onBlur('birthDay', e.target.value);
                            }}
                        />
                    </Column>

                    <Column size={8}>
                        <StyledTextBox
                            className="exclude-from-playback"
                            data-test="birth-year"
                            data-uem-id="birth-year"
                            name={BIRTH_YEAR}
                            placeholder="YYYY"
                            type="tel"
                            invalid={error}
                            onChange={(e) => {
                                onChange('birthYear', e.target.value);
                            }}
                            onFocus={() => {
                                onFocus('birthYear');
                            }}
                            onBlur={(e) => {
                                onBlur('birthYear', e.target.value);
                            }}
                        />
                    </Column>
                </Row>
                {this.maybeRenderInvalidErrorMessage()}
            </FormRow>
        );
    }

    maybeRenderInvalidErrorMessage() {
        const { error } = this.props;
        if (error) {
            return (
                <Row>
                    <ErrorMessage>Oops! Try a valid date.</ErrorMessage>
                </Row>
            );
        }
    }
}

// using first-child instead of ${Textbox} because styling against Textbox
// passes the styles down a level directly to the input, rather than the wrapper div
const Row = styled(BaseRow)`
    ${Column}:not(:first-child) > * {
        margin-left: -1px;
    }
`;

const StyledTextBox = styled(Textbox)`
    min-width: 0;
    ${(p) => (p.invalid ? `border-color: ${red80}` : '')};
`;

const FormLabel = styled.div`
    color: ${blue100};
    font: 15px/24px ${FontFamily.SharpSansSemibold};
`;
